// opervex-frontend/src/routes/RootRedirect.js

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OpervexStorage from "../utils/OpervexStorage";

const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const storedTenant = OpervexStorage.getTenantId();

    if (storedTenant && !OpervexStorage.isExpired()) {
      navigate(`/${storedTenant}`, { replace: true });
    } else {
      OpervexStorage.clear(); // limpa caso esteja expirado
      navigate("/StartTenent", { replace: true });
    }
  }, [navigate]);

  return null;
};

export default RootRedirect;
